import React from 'react';

const Footer = () => {
  return (
    <div className='text-center text-gray-300 font-semibold fixed mt-24 bottom-0 w-full py-4'>
      <p className='mt-3'>2022 Everlance, Inc</p>
    </div>
  );
};

export default Footer;
